import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { V2Card } from '@abyss/web/ui/Card/v2';

export const VirtualCareListViewContainer = styled(V2Card, {
  display: 'flex',
  maxWidth: '1200px',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'stretch',
  border: 'none',
  boxShadow: 'none',
  width: '100%',
  padding: '20px 0px 20px 0px',
});

export const VirtualCareListViewCardContent = styled('div', {
  display: 'flex',
  height: '111px',
  padding: '16px 16px 16px 32px',
  alignItems: 'flex-start',
  gap: '24px',
  alignSelf: 'stretch',
  borderRadius: '8px',
  background: '#FFF',
});

export const VirtualCareListViewCardBottomContent = styled('div', {
  display: 'flex',
  minWidth: '173px',
  height: '40px',
  paddingRight: '48px',
});

export const NetworkWrapper = styled('div', {
  lineHeight: '20px',
  color: '#323333',
  fontSize: '16px',
  marginLeft: '0px',
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  paddingLeft: '0px',
  alignItems: 'center',
});

export const inNetworkStatusTextStyle = (mobileScreen: boolean) => ({
  color: '#323333',
  fontSize: mobileScreen ? '14px' : '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: mobileScreen ? '18px' : '20px',
});

export const virtualCareProviderNameTextStyle = (mobileScreen: boolean) => ({
  color: '#196ECF',
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontSize: mobileScreen ? '16px' : '25.63px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: mobileScreen ? '20px' : '32px',
});

export const virtualCareServiceTypeTextStyle = (mobileScreen: boolean) => ({
  overflow: 'hidden',
  color: '#323333',
  fontFeatureSettings: "'liga' off, 'clig' off",
  textOverflow: 'ellipsis',
  fontSize: mobileScreen ? '14px' : '20.25px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: mobileScreen ? '18px' : '24px',
});

export const virtualCareOnlyTextStyle = (mobileScreen: boolean) => ({
  color: '#323333',
  fontSize: mobileScreen ? '14px' : '18px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: mobileScreen ? '18px' : '24px',
});

// Sizing for provider logo is now handled by ProviderLogoContainer and inline style in VirtualCareListCard.tsx
export const providerImageStyle = (mobileScreen: boolean) => ({
  width: mobileScreen ? '85px' : '150px',
  height: mobileScreen ? '22px' : '40px',
  objectFit: 'contain' as const,
  display: 'block',
});

export const getCareTextStyle = (disabled) => ({
  color: disabled ? '$gray' : '#002677',
  textAlign: 'center',
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '20px',
  height: '20px',
  minWidth: '61px',
});

export const virtualCareProviderCardLinkCss = (mobileScreen: boolean) => ({
  'abyss-link-root': {
    color: '#196ECF',
    fontSize: mobileScreen ? '16px' : '18px',
    lineHeight: '24px',
    fontWeight: 700,
    textAlign: 'center',
    marginLeft: '16px',
    marginTop: mobileScreen ? '8px' : '0px',
  },
});

export const GetCareButton = styled(Button, {
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  fontFamily: '$primary',
  '&.abyss-button-root': {
    minWidth: '125px',
    height: '40px',
    padding: '8px 16px',
    borderRadius: '24px',
    border: '1px solid #002677',
  },
});

export const ProviderLogoContainer = styled('div', {
  width: '150px',
  height: '38px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
});
